export default __webpack_public_path__ + "static/media/Pilgrim's Helm of the Purple Sun.c1173148.jpg";